import { createFileRoute } from "@tanstack/react-router";

import { TripleWhaleFormPage } from "~/pages/connection-new/triple-whale-form.page";

export const Route = createFileRoute(
  "/_app/settings/_organization/connections/new/_connection/triple_whale",
)({
  component: TripleWhaleFormPage,
});
